// 텍스트 검색 헬퍼 — 모든 네비게이션 검색에서 공통 사용.
//
// 동작:
//   - query 가 비어있으면 items 그대로 반환
//   - query 를 공백으로 split → 각 토큰이 fields 중 하나라도 포함하면 매치 (token AND, field OR)
//   - case-insensitive
//   - field 값이 falsy 이면 빈 문자열로 간주
//
// 사용 예:
//   filterByText(items, 'TBL fake', ['name', 'description', 'owner_name'])
//   → 'TBL' 포함 (name OR description OR owner_name) AND 'fake' 포함 (name OR description OR owner_name)

export function filterByText(items, query, fields) {
  if (!Array.isArray(items)) return []
  const q = (query || '').trim().toLowerCase()
  if (!q) return items
  const tokens = q.split(/\s+/).filter(Boolean)
  if (!tokens.length) return items
  const fieldList = Array.isArray(fields) && fields.length ? fields : ['name']

  return items.filter(item => {
    if (!item) return false
    return tokens.every(token => {
      return fieldList.some(field => {
        const val = item[field]
        if (val == null) return false
        return String(val).toLowerCase().includes(token)
      })
    })
  })
}

// query 안의 토큰을 추출 (highlight 컴포넌트용).
export function extractQueryTokens(query) {
  const q = (query || '').trim()
  if (!q) return []
  return q.split(/\s+/).filter(Boolean)
}
